import type { FC } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import type { IWidgetModelTypesType } from "app/components/widget/widget-types/Widget";

import { DataRow } from "../components/datarow/DataRow";
import { KeywordsOverviewPageTopMetricContainer } from "../KeywordsOverviewPageStyledComponents";

import type { SerpMetricRowData } from "app/common/keyword-research/keywords-overview/serpMetricsConsts";
import { serpRowsConfigs } from "app/common/keyword-research/keywords-overview/serpMetricsConsts";
import { ESerpMetric } from "app/common/keyword-research/keywords-overview/serpMetricsTypes";

const SerpMetricContainer = styled(KeywordsOverviewPageTopMetricContainer)`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    box-shadow: 2px 3px 6px 0 rgba(14, 30, 62, 0.08);
`;

interface ISerpMetrics {
    isLoading: boolean;
    metricItems: SerpMetricRowData;
}

export const SerpMetrics: FC<ISerpMetrics> = ({ isLoading, metricItems }) => {
    const { webSource } = useCurrentStateAndParams().params;
    const addToDashboardConfig = {
        metric: "KeywordOverviewCompetitiveStats",
        type: "KeywordOverviewStats" as IWidgetModelTypesType,
        webSource,
    };

    return (
        <SerpMetricContainer
            height="300px"
            padding="0"
            width="auto"
        >
            <DataRow
                key={ESerpMetric.ORGANIC}
                {...serpRowsConfigs.find((row) => row.id === ESerpMetric.ORGANIC)}
                {...metricItems.organicRowData}
                isLoading={isLoading}
                addToDashboardConfig={addToDashboardConfig}
            />
            <DataRow
                key={ESerpMetric.PAID}
                {...serpRowsConfigs.find((row) => row.id === ESerpMetric.PAID)}
                {...metricItems.paidRowData}
                isLoading={isLoading}
            />
            <DataRow
                key={ESerpMetric.CPC}
                {...serpRowsConfigs.find((row) => row.id === ESerpMetric.CPC)}
                {...metricItems.cpcRowData}
                isLoading={isLoading}
            />
        </SerpMetricContainer>
    );
};
